import { SimpleObject } from "types/types";
import React from "react";

interface ChildrenRenderProp {
  children: React.ReactNode;
  propsToChild?: SimpleObject;
}

const ChildrenRender = ({ children, propsToChild }: ChildrenRenderProp) => {
  if (typeof children === "string" || typeof children === "number") {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }
  if (!children && !Array.isArray(children)) {
    return null;
  }

  return (
    <>
      {React.Children.map(children, (child) => {
        if (child !== null && child !== undefined) {
          if (
            typeof child === "string" ||
            typeof child === "number" ||
            typeof child.type === "string"
          ) {
            return child;
          }
          if (
            typeof child === "boolean" ||
            (typeof child === "object" && Object.keys(child).length === 0)
          ) {
            return null;
          }
          return React.cloneElement(child, propsToChild);
        }
        return null;
      })}
    </>
  );
};

export default ChildrenRender;
